import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * TSG Nexus — "no interviews left" state for the interview rooms.
 *
 * Rendered INSTEAD of starting an interview when the backend answers the
 * generate-questions call with 402 / MOCK_INTERVIEW_CREDITS_EXHAUSTED. The
 * purchase modal (NexusQuotaExhaustedModal) is opened at the same time; this
 * is the surface left behind once it is dismissed, so the builder is never
 * dropped into a half-started interview or a dead screen.
 *
 * Only ever rendered inside /nextgen-builder/* — the learner app and the
 * college portals never reach it.
 */
const NexusInterviewBlocked = ({ message, backPath }) => {
  const navigate = useNavigate();
  return (
    <div className="text-center py-14">
      <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-8 border border-primary/20">
        <span className="text-5xl">🔒</span>
      </div>
      <h2 className="text-3xl font-black text-black mb-4 uppercase tracking-tighter">No Interviews Left</h2>
      <p className="text-muted mb-10 font-medium max-w-md mx-auto leading-relaxed">
        {message || "You've used all your free mock interviews for this month. Add interview credits to continue practising."}
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <button
          onClick={() => navigate('/nextgen-builder/plans?feature=MOCK_INTERVIEW')}
          className="btn-primary-gradient px-10 py-4 rounded-2xl font-black text-sm shadow-xl hover:scale-105 active:scale-95 transition-all uppercase tracking-widest"
        >
          Get Interviews
        </button>
        <button
          onClick={() => navigate(backPath)}
          className="px-10 py-4 rounded-2xl bg-bgMain text-muted border border-accentGray/50 font-black text-sm uppercase tracking-widest hover:text-white hover:border-primary transition-all"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default NexusInterviewBlocked;
